module.exports = __webpack_public_path__ + "static/media/add_icon.3c9184d3.svg";